import React, { Component } from "react";
import moment from "moment";
import API from "../../apiService";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Table from "../component/Table";
import Toastify from "toastify-js";
import "toastify-js/src/toastify.css";
import Pelayanan from "./PelayananPx";
import TableServerSidePagination from "view/component/ServerSideTable/TableServerSidePagination";
export default class Payment_list extends Component {
  constructor(props) {
    super(props);
    this.state = {
      datas: [],
      sendData: [],
      isLoading: true,
      clinic: [],
      frDate: moment(new Date()).format("YYYY-MM-DD"),
      enDate: moment(new Date()).format("YYYY-MM-DD"),
      paid: false,
      clinic_id: null,
      name: null,
      limit: "25",
      sort: "DESC",
      service: false,
      dat: "",
      puskesmas_id: JSON.parse(localStorage.getItem("puskesmasProfile"))
        ? JSON.parse(localStorage.getItem("puskesmasProfile")).code
        : "",
      paid: false,
    };
    this.handleClick = this.handleClick.bind(this);
    this.onHide = this.onHide.bind(this);
    this.showAll = this.showAll.bind(this);
  }
  componentDidMount() {
    this.fetchDatas();
    this.getClinic();
  }
  getClinic = async () => {
    const res = await API.get(
      "/apm/clinics/read/" + this.state.puskesmas_id + "/2/0"
    );
    if (res.code === 200) {
      this.setState({
        clinic: res.data,
      });
    }
  };
  fetchDatas = async () => {
    var param = {
      paid: this.state.paid,
      clinic_id: null,
      start_date: this.state.frDate,
      end_date: this.state.enDate,
      name: this.state.name,
    };

    const res = await API.post("registration/payment/list", param);
    if (res.code === 200) {
      // console.log(res)
      this.setState({
        datas: res.data,
        isLoading: false,
      });
    } else {
      this.setState({
        datas: [],
        isLoading: false,
      });
    }
  };
  createButtonSend(data, key) {
    if (data.paid) {
      return (
        <div>
          <button
            type="button"
            className="btn btn-sm btn-success"
            value={data.id}
            id={key}
            onClick={() => {
              this.handleClick(data);
            }}
          >
            v
          </button>
        </div>
      );
    } else {
      return (
        <div>
          <button
            type="button"
            className="btn btn-sm btn-primary"
            value={data.id}
            id={key}
            onClick={() => {
              this.handleClick(data);
            }}
          >
            +
          </button>
        </div>
      );
    }
  }
  createTotalHarga(datas, key) {
    const TotalArray = datas.biling;
    let total = 0;
    TotalArray.forEach((element) => {
      total += parseInt(element.price);
    });
    return total;
  }

  onHide() {
    this.setState(
      {
        service: false,
      },
      () => this.fetchDatas()
    );
  }
  handleClick(data) {
    this.setState({
      dat: data,
      service: true,
    });
  }
  showAll(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    if (value) {
      this.setState({ paid: true }, () => this.fetchDatas());
    } else {
      this.setState({ paid: false }, () => this.fetchDatas());
    }
  }

  render() {
    const frDate = moment(this.state.frDate).toDate();
    const enDate = moment(this.state.enDate).toDate();
    const { filteredDatas, isLoading } = this.state;
    const clinics = this.state.clinic.map((clinic, ky) => {
      if (clinic.clinic.child.length > 0) {
        return (
          <optgroup key={ky} label={clinic.clinic.name}>
            {clinic.clinic.child.map((cl) => {
              return (
                <option key={cl.id} value={cl.clinic_id}>
                  {cl.name}
                </option>
              );
            })}
          </optgroup>
        );
      } else {
        return (
          <option key={ky} value={clinic.clinic.id}>
            {clinic.clinic.name}
          </option>
        );
      }
    });
    return (
      <div>
        {this.state.service ? (
          <Pelayanan
            data={this.state.dat}
            close={this.onHide}
            {...this.props}
          />
        ) : (
          <div>
            <div className="row">
              <div className="col">
                <div className="card">
                  <div className="card-header border-0">
                    <div className="row">
                      <div className="col-md-2">
                        <h3>Kata Kunci</h3>
                      </div>

                      <input
                        className="form-control col-md-10"
                        name="name"
                        placeholder="nama"
                        type="text"
                        value={this.state.name}
                        onChange={(e) =>
                          this.setState({ name: e.target.value })
                        }
                      />
                    </div>
                    <div className="row" style={{ marginTop: "2%" }}>
                      {/* <div className="col-md-2">
                        <h3>Klinik</h3>
                      </div>

                      <select
                        className="form-control col-md-2"
                      // onChange={this.handleChange}
                      >
                        <option value="">Pilih Klinik</option>
                        {clinics}
                      </select> */}

                      <div className="col-md-2">
                        <h3>Tanggal Kunjungan</h3>
                      </div>
                      <DatePicker
                        className="form-control col-md-12"
                        selected={frDate}
                        onChange={(date) =>
                          this.setState({
                            frDate: moment(date).format("YYYY-MM-DD"),
                          })
                        }
                        value={this.frDate}
                        dateFormat="yyyy-MM-dd"
                      />
                      <DatePicker
                        className="form-control col-md-12"
                        selected={enDate}
                        onChange={(date) =>
                          this.setState({
                            enDate: moment(date).format("YYYY-MM-DD"),
                          })
                        }
                        value={this.enDate}
                        dateFormat="yyyy-MM-dd"
                      />
                      <button
                        style={{ marginLeft: "2%" }}
                        className="btn btn-success"
                        onClick={this.fetchDatas}
                      >
                        CARI DATA
                      </button>
                    </div>
                    <div className="row" style={{ marginLeft: "2%" }}>
                      <div className="custom-control custom-checkbox ">
                        <input
                          className="custom-control-input"
                          type="checkbox"
                          name="paid"
                          onChange={this.showAll}
                          value={this.state.paid}
                          id="paid"
                          checked={this.state.paid}
                        />
                        <label className="custom-control-label" htmlFor="paid">
                          sudah dilayani
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <div className="card">
                  <div className="card-header border-0" />
                  {/* <Table
                    headers={[
                      "No",
                      "Aksi",
                      "Tgl Kunjungan",
                      "Nama",
                      "No Bpjs",
                      "Umur",
                      "Jumlah",
                    ]}
                    data={this.state.datas}
                    columnMapper={(datas, key) => [
                      this.createButtonSend(datas, key),
                      datas.visit.created_at,
                      `${datas.patient.name} ${datas.patient.last_name}`,
                      datas.visit.insurance_no,
                      moment().diff(
                        datas.patient ? datas.patient.birth_date : "",
                        "years"
                      ) + " tahun",
                      this.createTotalHarga(datas, key),
                    ]}
                    pagination={true}
                  /> */}
                  <TableServerSidePagination
                    headers={[
                      "No",
                      "Aksi",
                      "Tgl Kunjungan",
                      "Nama",
                      "No Bpjs",
                      "Umur",
                      "Jumlah",
                    ]}
                    columnMapper={(datas, key) => [
                      this.createButtonSend(datas, key),
                      datas.visit.created_at,
                      `${datas.patient.name} ${datas.patient.last_name}`,
                      datas.visit.insurance_no,
                      moment().diff(
                        datas.patient ? datas.patient.birth_date : "",
                        "years"
                      ) + " tahun",
                      this.createTotalHarga(datas, key),
                    ]}
                    data={this.state.datas}
                    url={"registration/payment/list"}
                    bodyRequest={{
                      paid: this.state.paid,
                      clinic_id: null,
                      start_date: this.state.frDate,
                      end_date: this.state.enDate,
                      name: this.state.name,
                    }}
                    // callback={this.changePage}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}
